module.exports = __webpack_public_path__ + "dgrid.22R2VfFI.svg";